import React from 'react';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from 'recharts';
import {useCallback, useEffect, useRef, useState} from "react";
import graphsService from "./graph-service";

export function KpiLastMinutesGraphs() {
  const [data, setData] = useState([]);
  const [compare_graph_data, setGraphCompareData] = useState([]);

  const fill_colors= {
    users: '#0081a7',
    sessions: '#00afb9',
    clicks: '#457b9d',
    add_to_cart: '#1d3557',
    revenue: '#f07167',
    deals: '#9a031e',
    shopify_deals: '#e63946',
  };

  useEffect(() => {
    fetchData()
  }, []);

  const fetchData = useCallback(async () => {
    const res = await graphsService.fetchLastMinutesGraphData();

    setData(res);
  }, []);

  const CustomizedDot = (props) => {
    const {cx, cy, value} = props;

    if (value === 0) {
      return (
        <svg x={cx - 10} y={cy - 10} width={20} height={20} fill="red" viewBox="0 0 1024 1024">
          <path
            d="M517.12 53.248q95.232 0 179.2 36.352t145.92 98.304 98.304 145.92 36.352 179.2-36.352 179.2-98.304 145.92-145.92 98.304-179.2 36.352-179.2-36.352-145.92-98.304-98.304-145.92-36.352-179.2 36.352-179.2 98.304-145.92 145.92-98.304 179.2-36.352zM663.552 261.12q-15.36 0-28.16 6.656t-23.04 18.432-15.872 27.648-5.632 33.28q0 35.84 21.504 61.44t51.2 25.6 51.2-25.6 21.504-61.44q0-17.408-5.632-33.28t-15.872-27.648-23.04-18.432-28.16-6.656zM373.76 261.12q-29.696 0-50.688 25.088t-20.992 60.928 20.992 61.44 50.688 25.6 50.176-25.6 20.48-61.44-20.48-60.928-50.176-25.088zM520.192 602.112q-51.2 0-97.28 9.728t-82.944 27.648-62.464 41.472-35.84 51.2q-1.024 1.024-1.024 2.048-1.024 3.072-1.024 8.704t2.56 11.776 7.168 11.264 12.8 6.144q25.6-27.648 62.464-50.176 31.744-19.456 79.36-35.328t114.176-15.872q67.584 0 116.736 15.872t81.92 35.328q37.888 22.528 63.488 50.176 17.408-5.12 19.968-18.944t0.512-18.944-3.072-7.168-1.024-3.072q-26.624-55.296-100.352-88.576t-176.128-33.28z"/>
        </svg>
      );
    } else {
      return (<></>);
    }
  }

  return (
    <div>

      <div className="flex">
        <div className="w-full">
          <ResponsiveContainer width="100%"
                               height={300}>
            <LineChart
              data={data}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="7 1"/>
              <XAxis tick={{fill: "#fff"}} dataKey="full_hour"/>
              <YAxis tick={{fill: "#fff"}} yAxisId="left"/>
              <YAxis tick={{fill: "#fff"}} yAxisId="right" orientation="right"/>
              <Tooltip/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="users"         stroke={fill_colors['users']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="sessions"      stroke={fill_colors['sessions']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="clicks"        stroke={fill_colors['clicks']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="add_to_cart"   stroke={fill_colors['add_to_cart']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="revenue"       stroke={fill_colors['revenue']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="deals"         stroke={fill_colors['deals']}/>
              <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="shopify_deals" stroke={fill_colors['shopify_deals']}/>
              {/*<Line yAxisId="left" type="monotone" dataKey="shopify_revenue" stroke="#82ca9d"/>*/}
            </LineChart>
          </ResponsiveContainer>
        </div>
        {/* <div className="hidden md:w-1/6 2xl:w-1/6 md:flex 2xl:flex md:flex-col 2xl:flex-col">
          <button className="float-right bg-transparent hover:bg-red-400 border-red-400 text-red-400 font-semibold
           hover:text-white py-2 px-4 border hover:border-transparent rounded m-1" onClick={compareWithDate}>Compare</button>
          <button hidden={compare_graph_data.length === 0} className="float-right bg-transparent hover:bg-red-400 border-red-400 text-red-400 font-semibold
           hover:text-white py-2 px-4 border hover:border-transparent rounded m-1" onClick={hideCompare}>Hide</button>
        </div> */}
      </div>

      {
        compare_graph_data.length > 0 && (
          <>
            <hr/>
            <br/>
            <ResponsiveContainer width="100%"
                                 height={300}>
              <LineChart
                data={compare_graph_data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="7 1"/>
                <XAxis tick={{fill: "#fff"}} dataKey="full_hour"/>
                <YAxis tick={{fill: "#fff"}} yAxisId="left"/>
                <YAxis tick={{fill: "#fff"}} yAxisId="right" orientation="right"/>
                <Tooltip/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="users"         stroke={fill_colors['users']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="sessions"      stroke={fill_colors['sessions']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="clicks"        stroke={fill_colors['clicks']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="add_to_cart"   stroke={fill_colors['add_to_cart']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="revenue"       stroke={fill_colors['revenue']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="deals"         stroke={fill_colors['deals']}/>
                <Line dot={<CustomizedDot/>} yAxisId="left" type="monotone" dataKey="shopify_deals" stroke={fill_colors['shopify_deals']}/>
                {/*<Line yAxisId="left" type="monotone" dataKey="shopify_revenue" stroke="#82ca9d"/>*/}
              </LineChart>
            </ResponsiveContainer>
          </>
        )
      }

    </div>
  );
}
